export const AUTH_ERRORS = {
  REGISTRATION_DISABLED: 'registration_disabled',
  GENERIC_ERROR: 'generic_error',
  INVALID_OTP: 'That code is incorrect or expired.',
  RESEND_FAILED: 'Failed to resend code. Please try again.',
};

export const RESEND_COOLDOWN_SECONDS = 30;

export const TEST_CREDENTIALS = {
  EMAIL: 'singhabhyudita@gmail.com',
  OTP: '807103',
};
